  // const animalKeyword = [
  //   "animal", "cow", "dog", "cat", "lion", "tiger",
  //   "bird", "monkey", "horse", "sheep", "goat",
  //   "wildlife", "pet", "puppy", "kitten",
  //   "chicken", "hen", "duck", "fish",
  //   "zoo", "farm animal", "cattle", "hourse", "mosquitos", "mosquito", "tunisia", "spring", "bird", "spider"
  // ];

  const animalKeyword = [
  "animal", "cow", "dog", "cat", "lion", "tiger",
  "bird", "monkey", "horse", "sheep", "goat",
  "wildlife", "pet", "puppy", "kitten",
  "chicken", "hen", "duck", "fish",
  "zoo", "farm animal", "cattle", "mosquito", "spider", "grasshoppers", 
    "insect", "insects", "grasshopper", "grasshoppers",  "katydid", "bee", "honey bee", "butterfly", "moth",  "ant", "ants", "spider",  "bug", "bugs"


];

  function isAnimalImage(tag) {
  // if (!img?.tags) return false;

  // const tags = img.tags.toLowerCase();
const cleanTag = tag.toLowerCase();
  return animalKeyword.some(keyword =>  cleanTag.includes(keyword) );
}


export function GetTopTags(images, limit = 10) {
  const ignore = ["background", "wallpaper", "image", "photo", "nature"];

  const tagCount = {};

  images.forEach(img => {
    const tags = (img.tags || "").toLowerCase().split(", ");

    tags.forEach(tag => {
      if (ignore.includes(tag)) return;

      tagCount[tag] = (tagCount[tag] || 0) + 1;
    });
  });

  return Object.entries(tagCount)
    .sort((a, b) => b[1] - a[1])
    .slice(0, limit)
    .map(([tag]) => tag);
}

// export function BuildChips(tags, query) {
//   return tags.map(tag => {
//     if (tag.includes(query)) return tag;

//     return `${tag}`;
//   });
// }
// export function BuildChips(tags, query) {
//   const cleanQuery = query.toLowerCase().replace(/-/g, " ").trim();

//   const chips = [];

//   tags.forEach(tag => {
//     const cleanTag = tag.toLowerCase().trim();

//     // ✅ keep original tag
//     chips.push(cleanTag);

//     // 🔥 only enhance if it makes sense
//     if (!cleanTag.includes(cleanQuery) && cleanTag.length > 3) {
//       chips.push(`${cleanTag} ${cleanQuery}`);
//     }
//   });

//   // remove duplicates + limit
//   return [...new Set(chips)].slice(0, 10);
// }

export function BuildChips(tags, query) {
  const cleanQuery = query.toLowerCase().replace(/-/g, " ").trim();

  const chips = [];

  tags.forEach(tag => {
    const cleanTag = tag.toLowerCase().trim();

    // ❌ skip if tag is same as query
    if (cleanTag === cleanQuery) return;

    // ❌ skip if tag already contains full query (avoid repetition)
    if (cleanTag.includes(cleanQuery) || isAnimalImage(cleanTag)) return;

    // ✅ keep original tag
    chips.push(cleanTag);

    // 🔥 enhance only if meaningful
    if (cleanTag.length > 3) {
      const enhanced = `${cleanTag} ${cleanQuery}`
        .split(" ")
        .slice(0, 2)
        .join(" ");

      // ❌ avoid again if same as query
      if (enhanced !== cleanQuery) {
        chips.push(enhanced);
      }
    }
  });

  console.log("genrated chips", chips)

  return [...new Set(chips)].slice(0, 10);
}